exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form[data-v-12514ca2]  .el-row{padding:8px}[data-v-12514ca2] .el-form-item__error{position:relative}\n", ""]);

// exports
